<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.title  | translate }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <h2 class="static-content-heading-wrapper">{{ activeLanguageTranslations?.sggsProject }}</h2>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }}
        </div>

        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div>
        <div class="static-content-paragraph">
          <div class="text-center">
            <!-- <video (click)="openVideoPopup($event)">
              <source src="/assets/video/Navigation.mov" type="video/mp4">
            </video> -->
            <!-- <video style="width: 100%;" controls height="440" class="video" (play)="openVideoPopup()"  #videoPlayer>
              <source src="/assets/video/Navigation.mov" type="video/mp4">
              Your browser does not support the video tag.
            </video> -->
        <iframe style="max-width: 560px; height:315px;" width="100%" height="auto" frameborder="0"
          [src]="safeURL" title="YouTube video on How to Navigate Guru Granth Sahib.io"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>

            <!-- <img (click)="openVideoPopup()" alt ="play-button" src="/assets/images/play.webp" /> -->
          </div>

       </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div>
        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.subTitle2 }}</div>

        <ul style="list-style-type: auto;">
          <li class="navigation-li">
            <span>{{activeLanguageTranslations?.subTitleContent1}}</span>
            <div class="static-content1">
              {{ activeLanguageTranslations?.subTitleContent1Para }}
            </div>
          </li>
          <li class="navigation-li">
            <span>{{activeLanguageTranslations?.subTitleContent2}}</span>
            <div class="static-content1">
              {{ activeLanguageTranslations?.subTitleContent2Para }}
            </div>
          </li>
          <li class="navigation-li">
            <span>{{activeLanguageTranslations?.subTitleContent3}}</span>
            <div class="static-content1">
              {{ activeLanguageTranslations?.subTitleContent3Para }}
            </div>
          </li>
        </ul>
        


        

        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
